import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { maintenanceService } from "../../services/maintenance-service";

export const useGetMaintenanceStatus = () => {
  return useQuery({
    queryKey: ["maintenance-status"],
    queryFn: () => maintenanceService.getMaintenanceStatus(),
  });
};

export const useToggleMaintenance = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["toggle-maintenance"],
    mutationFn: () => maintenanceService.toggleMaintainance(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["maintenance-status"] });
    },
  });
};
